export function fmtInitials(g: { first_name?: string | null; last_name?: string | null }): string {
  const a = (g.first_name || '').trim().charAt(0);
  const b = (g.last_name || '').trim().charAt(0);
  return (a + b).toUpperCase() || '?';
}

export const AVATAR_BG = ['#F3D1C8', '#D9D6F2', '#C9E4D4', '#F5E2B8', '#E8C4D8', '#C8D9F0', '#F0D0C0', '#D4E8D0'];

export function avatarColor(id: string): string {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) | 0;
  return AVATAR_BG[Math.abs(h) % AVATAR_BG.length];
}
